import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_DISCOUNT_CODE_AUTHORIZER,
  CLEAR_DISCOUNT_CODE_AUTHORIZERS,
  FLAG_DISCOUNT_CODE_AUTHORIZER_ACTIVITY,
  FLAG_GETTING_DISCOUNT_CODE_AUTHORIZERS,
  GET_DISCOUNT_CODE_AUTHORIZER,
  GET_DISCOUNT_CODE_AUTHORIZERS,
} from '../../../actions/types/sales/DiscountCodeAuthorizer';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DISCOUNT_CODE_AUTHORIZERS:
      return state.setIn(['all', 'loading'], payload);
    case GET_DISCOUNT_CODE_AUTHORIZERS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DISCOUNT_CODE_AUTHORIZERS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_DISCOUNT_CODE_AUTHORIZER:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DISCOUNT_CODE_AUTHORIZER:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_DISCOUNT_CODE_AUTHORIZER_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
